var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGatewayStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#2F3A51"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7088 14.188C22.0454 13.0204 18.2175 12.2764 16.5115 12.0503L6.21708 16.0899M23.7088 14.188L14.6358 20.0411M23.7088 14.188C24.1392 15.5444 23.7427 16.7976 23.4907 17.2546L14.6358 23.9038M14.6358 20.0411C13.0606 18.9452 9.17163 16.6207 6.21708 16.0899M14.6358 20.0411V23.9038M6.21708 16.0899C6.04745 16.8664 5.8594 18.6287 6.46426 19.4661C9.18811 21.1419 14.6358 24.3756 14.6358 23.9038",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0498 18.175L14.6417 22.697L23.8998 16.075",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8262 9.20975C15.6216 9.32052 15.434 9.46021 15.2693 9.62453C15.1033 9.79036 14.9624 9.97951 14.8511 10.186L15.37 10.7049C15.7166 9.81629 16.7179 9.37699 17.6065 9.72365C18.0564 9.89915 18.4122 10.255 18.5877 10.7049L19.1066 10.186C18.4703 9.01056 17.0017 8.57349 15.8262 9.20975Z",
    fill: "#00CBAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6163 7.71731C14.412 7.86042 14.2211 8.02175 14.0459 8.19932C13.8827 8.36464 13.7338 8.54338 13.6006 8.73368L14.0962 9.22544C15.1514 7.63116 17.2993 7.19414 18.8936 8.24934C19.2812 8.50587 19.6131 8.83784 19.8696 9.22544L20.3653 8.72981C19.0573 6.86266 16.4834 6.40934 14.6163 7.71731Z",
    fill: "#00CBAF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3903 6.28261C13.1903 6.43812 13.0007 6.60647 12.8225 6.78658C12.6548 6.95126 12.497 7.12582 12.3501 7.30932L12.8457 7.80497C14.5492 5.52459 17.7788 5.05692 20.0592 6.76041C20.2697 6.91768 20.4679 7.09084 20.652 7.27834C20.8147 7.44355 20.966 7.61948 21.1051 7.80495L21.6007 7.30931C19.617 4.75857 15.9411 4.29888 13.3903 6.28261Z",
    fill: "#00CBAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatewayStatus);
export default __webpack_public_path__ + "static/media/gateway-status.9b9d070fc27629429ee013d3c26a00b2.svg";
export { ForwardRef as ReactComponent };